jQuery( function ( $ ) {
	// set all visible inputs to required
	$( '[data-required="1"]' ).attr( 'required', true );

	// remove required attribute to nested inputs so it doesn't prevent form submission
	$( '.nested:not(.displayed)' ).each( ( _, el ) => {
		$( el ).find( 'input[data-required="1"]' ).attr( 'required', false );
		$( el ).find( 'textarea[data-required="1"]' ).attr( 'required', false );
		$( el ).find( 'select[data-required="1"]' ).attr( 'required', false );
	} );
	
	function handleSkipAnswerInput() {
		const checkedInputName = $( this ).attr( 'name' );
		const closestHiddenInput = $( `input[data-id="${  checkedInputName  }"]` ).closest( 'input[data-validation="true"]' );
		
		if ( !$( this ).is( ':checked' ) ) {
			closestHiddenInput.attr( 'required', true );
			closestHiddenInput.attr( 'data-required', 1 );
			return;
		} else {
			closestHiddenInput.attr( 'required', false );
			closestHiddenInput.attr( 'data-required', 0 );
		}

		const isSkipAnswer = 1 === $( this ).data( 'skipAnswer' );

		const nestedQuestions = $( `div.form-group[data-parent-id="${$( this ).data( 'questionId' )}"]` );
		if ( isSkipAnswer ) {
			nestedQuestions.removeClass( 'displayed' );
			nestedQuestions.find( '[data-required="1"]' ).attr( 'required', false );
		} else {
			nestedQuestions.addClass( 'displayed' );
			nestedQuestions.find( '[data-required="1"]' ).attr( 'required', true );
		}
	}

	function handleOptionalAnswerRadioInput() {
		if ( !$( this ).is( ':checked' ) ) {
			return;
		}

		const isOptionalAnswer = 1 === $( this ).data( 'optionalAnswer' );

		const optionalAnswer = $( `div.form-group[data-optional-field="${$( this ).data( 'questionId' )}"]` );
		if ( isOptionalAnswer ) {
			optionalAnswer.addClass( 'displayed' );
		} else {
			optionalAnswer.removeClass( 'displayed' );
		}
	}

	function handleOptionalAnswerCheckboxInput() {
		const isOptionalAnswer = 1 === $( this ).data( 'optionalAnswer' );

		if ( !isOptionalAnswer ) {
			return;
		}

		const optionalAnswer = $( `div.form-group[data-optional-field="${$( this ).data( 'questionId' )}"]` );
		if ( $( this ).is( ':checked' ) ) {
			optionalAnswer.addClass( 'displayed' );
		} else {
			optionalAnswer.removeClass( 'displayed' );
		}
	}

	function handleAllAndNoneAnswersCheckboxInput() {
		const isAllAnswer = 1 === $( this ).data( 'allAnswer' );
		const isNoneAnswer = 1 === $( this ).data( 'noneAnswer' );

		if ( ( isAllAnswer || isNoneAnswer ) && $( this ).is( ':checked' ) ) {
			let selector = `[name="${$( this ).attr( 'name' )}"]`;

			if ( isAllAnswer ) {
				selector += '[data-all-answer="0"]';
			}

			if ( isNoneAnswer ) {
				selector += '[data-none-answer="0"]';
			}

			$( selector ).attr( 'checked', false );

			const optionalAnswer = $( `div.form-group[data-optional-field="${$( this ).data( 'questionId' )}"]` );
			optionalAnswer.removeClass( 'displayed' );
		} else if ( !isAllAnswer && !isNoneAnswer ) {
			$( `[name="${$( this ).attr( 'name' )}"][data-all-answer="1"]` ).attr( 'checked', false );
			$( `[name="${$( this ).attr( 'name' )}"][data-none-answer="1"]` ).attr( 'checked', false );
		}
	}

	function handleSkipAnswerSelect() {
		const selectedOption = $( this ).find( 'option:checked' );

		const isSkipAnswer = 1 === selectedOption.data( 'skipAnswer' );

		const nestedQuestions = $( `div.form-group[data-parent-id="${$( this ).data( 'questionId' )}"]` );
		if ( isSkipAnswer ) {
			nestedQuestions.removeClass( 'displayed' );
			nestedQuestions.find( '[data-required="1"]' ).attr( 'required', false );
		} else {
			nestedQuestions.addClass( 'displayed' );
			nestedQuestions.find( '[data-required="1"]' ).attr( 'required', true );
		}
	}

	function handleImageFieldChange() {
		const hiddenField = $( this ).closest( '.file-upload-wrapper' ).find( 'input[type="hidden"]' );

		if ( $( this ).val() ) {
			hiddenField.attr( 'disabled', true );
		} else {
			hiddenField.attr( 'disabled', false );
		}

		validateImageField( $( this ) );
	}

	function handleImageFieldClear() {
		const hiddenField = $( this ).closest( '.file-upload-wrapper' ).find( 'input[type="hidden"]' );
		hiddenField.attr( 'disabled', false );
	}

	function handleUrlFieldChange() {
		const urlField = $( this );

		const url = urlField.val();

		if ( url ) {
			const urlRegex = new RegExp( /^http(s?):\/\/(.+)$/ );

			if ( !urlRegex.test( url ) ) {
				urlField.val( `http://${url}` );
			}
		}
	}

	function stopFormSubmit( event, form ) {		
		event.preventDefault();
		event.stopPropagation();

		$( 'input[name="draft"]' ).val( 1 );
		$( '.btn-holder button', $( form ) ).attr( 'disabled', false );
	}

	function validateCheckboxGroup( checkboxGroup ) {
		checkboxGroup.each( function () {
			const checkboxes = $( this ).find( 'input[type="checkbox"]' );
			const checkedCheckboxes = $( this ).find( 'input[type="checkbox"]:checked' );

			if ( 0 === checkedCheckboxes.length ) {
				checkboxes.each( function () {
					this.setCustomValidity( 'Please select at least one value for this field' );
				} );
			} else {
				checkboxes.each( function () {
					this.setCustomValidity( '' );
				} );
			}
		} );
	}

	function validateCheckbox( checkbox ) {
		const checkboxGroup = checkbox.closest( '.checkbox-group' );

		if ( 0 === checkboxGroup.data( 'required' ) ) {
			return;
		}

		validateCheckboxGroup( checkboxGroup );
	}

	function validateImageField( imageField ) {
		if ( 0 === imageField.data( 'required' ) ) {
			return;
		}

		const hiddenField = imageField.closest( '.file-upload-wrapper' ).find( 'input[type="hidden"]' );

		if ( imageField.val() ) {
			imageField.each( function () {
				this.setCustomValidity( '' );
			} );
		} else if ( $( hiddenField ).val() ) {
			imageField.each( function () {
				this.setCustomValidity( '' );
			} );
		} else {
			imageField.each( function () {
				this.setCustomValidity( 'Please provide an image for this field.' );
			} );
		}
	}

	function handleFormSubmit( event, form ) {
		$( '.btn-holder button', $( form ) ).attr( 'disabled', true );

		const draftField = $( 'input[name="draft"]' );
		const draft = parseInt( draftField.val() );

		const requiredFields = $( 'input[required], select[required]' );
		const requiredCheckboxGroups = $( '.checkbox-group[data-required="1"]' );
		const requiredImageFields = $( 'input[type="file"][data-required="1"]' );

		if ( draft ) {
			requiredFields.attr( 'required', false );

			requiredCheckboxGroups.find( 'input[type="checkbox"]' ).each( function () {
				this.setCustomValidity( '' );
			} );

			requiredImageFields.each( function () {
				this.setCustomValidity( '' );
			} );
		}

		let formValid = true;
		$( 'input,select', $( form ) ).each( function () {
			if ( !$( this ).is( ':hidden' ) ) {
				const fieldValid = this.reportValidity();

				if ( !fieldValid ) {
					formValid = false;
				}
			}
		} );

		if ( !formValid ) {
			stopFormSubmit( event, form );
		}

		requiredFields.attr( 'required', true );

		requiredCheckboxGroups.each( function () {
			validateCheckboxGroup( $( this ) );
		} );

		requiredImageFields.each( function () {
			validateImageField( $( this ) );
		} );
	}

	function submitFormAsDraft() {
		storeSections();
		$( 'input[name="draft"]' ).val( 1 );
		$( '#application-form' ).submit();
	}

	const applicationForm = $( '#application-form' );
	const applicationFormSubmitBtn = $( '#application-form-submit' );

	const isNestedAndNotAnswered = ( el ) => {
		const parent = $( el ).closest( '.form-group.nested' );

		if( !parent.length ) {
			return true;
		}

		if( parent && parent.hasClass( 'nested' ) && parent.hasClass( 'displayed' ) ){
			return true;
		}

		return false;
	};

	applicationFormSubmitBtn.on( 'click', function() {
		$( '.required-text' ).hide();

		$( 'input[required], input[data-required="1"]' ).each( function() {	
			if( !isNestedAndNotAnswered( this ) ) return;

			if ( '' === $( this ).val() ) {
				$( this ).closest( '.section' ).find( '.required-text' ).show();
			}
		} );

		$( 'textarea[required], textarea[data-required="1"]' ).each( function() {	

			if( !isNestedAndNotAnswered( this ) ) return;
			
			if ( '' === $( this ).val() ) {
				$( this ).closest( '.section' ).find( '.required-text' ).show();
			}
		} );

		$( 'input[type=checkbox][required], input[type=checkbox][data-required="1"]' ).each( function() {
			if( !isNestedAndNotAnswered( this ) ) return;
			
			if ( !$( `input[name="${  $( this ).attr( 'name' )  }"]:checked` ).length ) {
				$( this ).closest( '.section' ).find( '.required-text' ).show();
			}
		} );
		

		$( 'input[type=radio][required], input[type=radio][data-required="1"]' ).each( function() {
			if( !isNestedAndNotAnswered( this ) ) return;
			
			if ( !$( `input[name="${  $( this ).attr( 'name' )  }"]:checked` ).length ) {
				$( this ).closest( '.section' ).find( '.required-text' ).show();
			}
		} );	  

		$( 'select[required], select[data-required="1"]' ).each( function() {
			if( !isNestedAndNotAnswered( this ) ) return;
			
			if ( '' === $( this ).val() ) {
				$( this ).closest( '.section' ).find( '.required-text' ).show();
			}
		} );
	} );

	$( 'input[type="radio"], input[type="checkbox"]', applicationForm ).on( 'change', handleSkipAnswerInput );
	$( 'input[type="radio"]', applicationForm ).on( 'change', handleOptionalAnswerRadioInput );
	$( 'input[type="checkbox"]', applicationForm ).on( 'change', handleOptionalAnswerCheckboxInput );
	$( 'input[type="checkbox"]', applicationForm ).on( 'change', handleAllAndNoneAnswersCheckboxInput );

	$( 'input[type="checkbox"]', applicationForm ).on( 'change', function () {
		validateCheckbox( $( this ) );
	} );

	$( 'select', applicationForm ).on( 'change', handleSkipAnswerSelect );
	$( 'input[type="file"]', applicationForm ).on( 'change', handleImageFieldChange );
	$( 'input[type="file"]', applicationForm ).on( 'file_upload.afterClear', handleImageFieldClear );
	$( 'input[type="url"]', applicationForm ).on( 'change', handleUrlFieldChange );

	$( applicationForm ).on( 'submit', function ( e ) {
		$( 'input[type="checkbox"]' ).each( function () {
			validateCheckbox( $( this ) );
		} );

		$( 'input[type="file"]' ).each( function () {
			validateImageField( $( this ) );
		} );

		handleFormSubmit( e, this );
	} );

	$( '#application-form-save-for-later' ).on( 'click', submitFormAsDraft );
	$( '#application-form-save-for-later-alert-message' ).on( 'click', submitFormAsDraft );

	$( '.close-save-form-alert' ).on( 'click', function (){
		$( '#save-form-alert' ).addClass( 'display-none' );
	} );
	$( '#application-form-save-for-later-alert-message' ).on( 'click', function (){
		$( '#save-form-alert' ).addClass( 'display-none' );
	} );

	function displaySaveFormMessage(){
		// This code runs every 15 mins
		$( '#save-form-alert' ).removeClass( 'display-none' );
	}

	function isJson( value ) {
		if ( !value ) return false;
		
		try {
			JSON.parse( value );
			return true;
		} catch ( error ) {
			return false;
		}
	}
	
	const getAccordionItems = () => {
		return window.localStorage.getItem( localStorageKey );
	};
	
	const getAccordionItemsList = () => {
		const accordionItems = getAccordionItems();
		return ( accordionItems && isJson( accordionItems ) && JSON.parse( accordionItems ) ) ? JSON.parse( accordionItems ).map( ( accordionItem ) => accordionItem.replace( '#', '' ) ) : null;
	};

	const localStorageKey = 'active-accordion-sections';
	
	function restoreAccordionState(){
		
		const accordionDOMItems = $( '#application-form .collapse' );

		if( !accordionDOMItems.length ){
			return;
		}
		
		const selectedIds = [];
		
		accordionDOMItems.each( function() {
			const id = $( this ).attr( 'id' );
			selectedIds.push( `#${id}` );
		} );
		
		// edge-case: logic to handle cases there are old question id's in the localstorage
		if( selectedIds && ( getAccordionItemsList() && getAccordionItemsList().length ) ){
			const filtered = getAccordionItemsList().filter( ( accordionItemsListItem ) => selectedIds.includes( `#${accordionItemsListItem}` ) ).map( ( accordionItemsListItem ) => `#${accordionItemsListItem}` );
			if( filtered.length ){
				window.localStorage.setItem( localStorageKey, JSON.stringify( filtered ) );
			} else {
				window.localStorage.setItem( localStorageKey, JSON.stringify( [] ) );
			}
		}

		if( $( '#saved-for-later' ).length ) {
			accordionDOMItems.each( function( _, accordionDOMItem ) {
				if ( !getAccordionItemsList() ) return;
				
				if ( getAccordionItemsList().includes( accordionDOMItem.id ) ) {
					$( accordionDOMItem ).addClass( 'show' );
					$( `[data-target="#${accordionDOMItem.id}"]` ).removeClass( 'collapsed' );
				} else {
					$( accordionDOMItem ).removeClass( 'show' );
					$( `[data-target="#${accordionDOMItem.id}"]` ).addClass( 'collapsed' );
				}
			} );
		}		
	}

	let tempList = getAccordionItemsList() ? getAccordionItemsList().map( ( accordionItem ) => `#${accordionItem}` ) : [];

	function handleAccordionClick() {
		const dataTarget = $( this ).attr( 'data-target' );

		if ( !tempList.includes( dataTarget ) && $( this ).hasClass( 'collapsed' ) ) {
			tempList.push( dataTarget );
		} else {
			const filtered =  tempList.filter( accordionItem => accordionItem !== dataTarget );			
			tempList = filtered;
		}
	}
		
	$( '.questionnaire-accordion .card-header' ).on( 'click', handleAccordionClick );
	
	function storeSections(){
		window.localStorage.setItem( localStorageKey, JSON.stringify( tempList ) );
	}

	restoreAccordionState();

	setInterval( displaySaveFormMessage, 900000 );


} );


